import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-5 py-12 text-foreground">
      <div className="w-full max-w-lg border-l-2 border-primary pl-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">TrustFile</p>
        <h1 className="mt-3 font-heading text-3xl font-semibold tracking-tight">Missing screen</h1>
        <p className="mt-3 max-w-md leading-7 text-muted-foreground">
          The screen you requested is not available. Return to the TrustFile front door.
        </p>
        <Button render={<Link to="/" />} className="mt-7" data-jr-key="missing-screen-home">
          Return to TrustFile
        </Button>
      </div>
    </main>
  );
}
